import axios from 'axios';

const API_SERVER_URL = process.env.REACT_APP_API_URL;

const api = axios.create({
    baseURL: `${API_SERVER_URL}/api` // This should be the URL of your server. Adjust if it's different.
});

export default api;